// Genera un archivo .ics para "Añadir al calendario"
export const downloadICS = () => {
  const start = "20270604T160000Z"; // 18:00 CEST = 16:00 UTC
  const end = "20270605T040000Z"; // hasta ~04:00 UTC del día siguiente
  const dtstamp =
    new Date().toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Macarena y Virginia//Boda//ES",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:macarena-virginia-boda-${Date.now()}@boda.es`,
    `DTSTAMP:${dtstamp}`,
    `DTSTART:${start}`,
    `DTEND:${end}`,
    "SUMMARY:Boda Macarena & Virginia",
    "DESCRIPTION:Nos casamos. Nos hace muchísima ilusión celebrarlo con vosotros.",
    "LOCATION:Cortijo de Enmedio\\, Carr. de la Zubia 103D\\, 18006 Granada\\, España",
    "GEO:37.1100;-3.6000",
    "STATUS:CONFIRMED",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");

  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "Macarena-Virginia-Boda.ics";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
